module.exports = __webpack_public_path__ + "static/media/jackbanner_sm2.b8f27904.png";